import { DrawerClose, DrawerDescription, DrawerHeader, DrawerTitle } from '@/shadcn/ui/drawer'
import { TabSelector } from '@/features/side-drawer/components/TabSelector'
import { Typography } from '@/ui/atoms/typography/Typography'
import { ChevronsRight } from 'lucide-react'

import { TokensTab } from '@/features/side-drawer/components/tabs/TokensTab'
import { ButtonGroup } from '@/features/side-drawer/components/ButtonGroup'
import { WalletButton } from '@/features/side-drawer/components/WalletButton'
import { DynamicUserProfile } from '@dynamic-labs/sdk-react-core'
import { PositionsTab } from '@/features/side-drawer/components/tabs/PositionsTab'
import { useAccountOverview } from '@/features/side-drawer/logic/useAccountOverview'
import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import { SideDrawerTabs } from '@/domain/state/sideDrawer'
import { Info } from '@/ui/molecules/info/Info'
import { SettingsPopOver } from '@/features/side-drawer/components/SettingsPopover'

export function AccountOverview({ setMobileMenuCollapsed }: { setMobileMenuCollapsed: (open: boolean) => void }) {
  const { tokenData, positionData, totalUSD } = useAccountOverview()
  const { activeTab } = useSideDrawer()
  return (
    <>
      <DrawerHeader className="gap-0 text-left">
        <div>
          <div className="flex items-center justify-between">
            <DrawerClose className="transition-colors hover:text-primary">
              <ChevronsRight className="h-4 w-4" />
            </DrawerClose>

            <div className="flex items-center gap-2">
              <WalletButton />
              <SettingsPopOver />
            </div>
          </div>
        </div>
        <DrawerDescription className="mt-3 mb-1 pl-1">
          <span className="flex items-center gap-1">
            <Typography variant="prompt">HypurrFi net position</Typography>
            <Info>The dollar value of your deposits minus your borrows in HypurrFi.</Info>
          </span>
        </DrawerDescription>
        <DrawerTitle className="pb-4 pl-1" asChild>
          <Typography variant="h1" className="text-4xl lg:text-4xl">
            {totalUSD.split('.')[0]}
            <span className="text-white/40">.{totalUSD.split('.')[1]}</span>
          </Typography>
        </DrawerTitle>

        <ButtonGroup />

        <div className="pt-7 pl-1">
          <TabSelector highestRiskLevel={positionData.highestRiskLevel} />
        </div>
      </DrawerHeader>

      <div className="p-4">
        {(() => {
          switch (activeTab) {
            case SideDrawerTabs.TOKENS:
              return <TokensTab {...tokenData} />
            case SideDrawerTabs.POSITIONS:
              return <PositionsTab positionData={positionData} setMobileMenuCollapsed={setMobileMenuCollapsed} />
          }
        })()}
      </div>

      <DynamicUserProfile />
    </>
  )
}
